(ns ycweb.app.website.registry.collections
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

;; Starter Collection Card
(rum/defc starter-collection-card < rum/reactive [app-atom collection]
  [:div
   {:class (u/bem :flex-grid-block [:ml-1-3 :t-1-2])}
   [:article.card.info-card.flex-grid-content
    [:a.u-block-link
     (urlstate/href-props app-atom "registry" "collectiondetail"
       {:uuid (:ent/uuid collection)
        :registry-uuid (:registry-uuid (cmn/screen-params app-atom))})
     [:figure.card__hero
      (web-common/lazy-image app-atom
        (:doc/public-id (:ent/image collection))
        {:class ["card__image"]}
        {:w 300
         :c "lpad"
         :q "auto"
         :alt ""})]
     [:div.card__content-wrapper
      [:div.card__content
       [:h1.card__title (:ent/display-name collection)]
       [:p.info-card__description (:collection/description collection)]]
      [:div.info-card__footer
       (buttons/button-web "View collection"
         {:type :span-button
          :style :secondary
          :size :small
          :class :info-card__button})]]]]])

;; Registry Starter Collections
(rum/defc starter-collections < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        collections (cmn/curact process-atom [:collections])]
    [:div
     {:class (u/bem :yc-page-content [:medium])}
     [:div
      {:class (u/bem :yc-section [:medium])}
      [:div.yc-intro-text
       (headings/heading "Get Started with our Collections"
         {:type :h1
          :size :large
          :center true})
       [:p.yc-paragraph.u-text-center
        "Overwhelmed by all the choice and not sure where to start? Browse our hand-picked collections and choose to add either individual products or the entire collection to your registry."]]]
     [:div
      {:class (u/bem :yc-section [:large])}
      [:div
       {:class (u/bem :flex-grid-group [:align-left])}
       (map
         (fn [collection]
           (rum/with-key
             (starter-collection-card app-atom collection)
             (str (:ent/uuid collection))))
         (sort-by :collection/position collections))
       (toaster/loading-overlay app-atom :web.registry/collection-list)]]]))

(rum/defc collection-nav [app-atom collection-name]
  (let [registry-uuid (:registry-uuid (cmn/screen-params app-atom))]
    [:nav
     {:class (u/bem :yc-section [:standard])}
     [:ul.breadcrumbs.group
      [:li.breadcrumbs__item
       [:a.breadcrumb__link (urlstate/href-props app-atom "registry" "") "Registry"]]
      [:li.breadcrumbs__item
       [:a.breadcrumb__link (urlstate/href-props app-atom "registry" "edit" {:uuid registry-uuid}) "Manage"]]
      [:li.breadcrumbs__item
       [:a.breadcrumb__link (urlstate/href-props app-atom "registry" "collectionlist") "Starter Collections"]]
      [:li.breadcrumbs__item
       [:span.breadcrumb__current-text collection-name]]]]))

(defmethod grid/action :web.registry/collection.add-item [app-atom config _]
  (toaster/open-toast app-atom :processing "Adding item to your registry" {:closetime 10000})
  (let [collection-item-uuid (cmn/curact (cmn/process-cursor app-atom) [:collection-item/uuid])]
    (comms/ajax-post :web.registry/collection.add-item
      {:collection-item/uuid collection-item-uuid
       :registry/uuid (:ent/uuid (:registry config))})))

(defmethod comms/receive :web.registry/collection.add-item [app-atom {:keys [success] :as collection-response}]
  (toaster/close-toast app-atom)
  (cond
    success
    (grid/open-modal app-atom :web.registry/collection-added-modal
      {:config
       {:title "Item added"
        :registry/uuid (:registry/uuid collection-response)}})

    :else
    (toaster/open-toast app-atom :error "Item could not be added" {})))

(defmethod grid/action :web.registry/collection.add [app-atom config _]
  (toaster/open-toast app-atom :processing "Adding collection to your registry" {:closetime 10000})
  (let [collection-uuid (cmn/curact (cmn/process-cursor app-atom) [:collection/uuid])]
    (comms/ajax-post :web.registry/collection.add
      {:collection/uuid collection-uuid
       :registry/uuid (:ent/uuid (:registry config))})))

(defmethod comms/receive :web.registry/collection.add [app-atom {:keys [success] :as collection-response}]
  (toaster/close-toast app-atom)
  (cond
    success
    (grid/open-modal app-atom :web.registry/collection-added-modal
      {:config
       {:title "Collection added"
        :registry/uuid (:registry/uuid collection-response)}})

    :else
    (toaster/open-toast app-atom :error "Collection could not be added" {})))

(rum/defc collection-product-card < rum/reactive
  < {:key-fn (fn [_ collection-item] (:ent/uuid collection-item))}
  [app-atom collection-item]
  (let [process-atom (cmn/process-cursor app-atom)
        {:item-line/keys [variation product]} collection-item
        {:product/keys [link name-ex-brand brand-name reviews]} product
        {:variation/keys [price]} variation
        {:reviews/keys [stars-avg reviews-total]} reviews
        collection-uuid (cmn/curact process-atom [:collection :ent/uuid])
        user (cmn/curact app-atom [:user])]

    [:div
     {:class (u/bem :flex-grid-block [:ml-1-4 :t-1-2])}
     [:article.card.product-card.flex-grid-content
      [:div.card__hero
       [:a.u-block-link
        {:href link}
        (web-common/lazy-image app-atom
          (:doc/public-id (:ent/image variation))
          {:class ["card__image"]}
          {:w 233
           :h 233
           :q "auto"
           :c "lpad"
           :dpr 2
           :alt (str "Image of " (:ent/display-name product))})]]
      [:div.card__content-wrapper
       [:a.u-block-link
        {:href link}
        [:div.card__content
         [:header.card__header
          (cond
            (and stars-avg (pos? stars-avg))
            [:div.product-card__meta
             [:div
              {:class (u/bem :star-rating [:small] (str "star-rating--" (* stars-avg 10)))
               :title (str (int stars-avg) " out of 5 stars from " reviews-total " reviews")}
              [:span.u-hidden-from-view
               (str (int stars-avg) " out of 5 stars from " reviews-total " reviews")]]]
            :else
            [:div
             {:class (u/bem :star-rating [:small] "star-rating--0")
              :title "This product has not been reviewed yet."}
             [:span.u-hidden-from-view "This product has not been reviewed yet."]])
          [:h1.product-card__title
           [:span.product-card__brand brand-name]
           [:span.product-card__name name-ex-brand]]]
         [:div.card__description
          [:ul.card-price-list.group
           [:li.card-price-list__item
            (str "R" (u/currency-format price))]]]]]
       [:div.product-card__cta
        (cond
          user
          (buttons/button-web "Add to registry"
            {:type :button
             :style :secondary
             :size :small
             :class :product-card__button
             :on-click
             #(do
                (swap! process-atom assoc
                  :collection-item/uuid (:ent/uuid collection-item)
                  :registry-action :add-collection-item)
                (grid/dispatch-action app-atom :web.registry/edit.choose {}))})

          :else
          (buttons/button-web "Add to registry"
            {:type :button
             :style :secondary
             :size :small
             :class :product-card__button
             :on-click #(grid/open-modal app-atom :web.registry/no-registry-modal)}))]]]]))

;; Starter Collection
(rum/defc starter-collection < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:collection/keys [banner description items] :as collection} (cmn/curact process-atom [:collection])
        user (cmn/curact app-atom [:user])]
    [:div
     {:class (u/bem :yc-page-content [:standard])}
     (collection-nav app-atom (:ent/display-name collection))
     [:div
      {:class (u/bem :yc-section [:medium-underline])}
      [:div.callout-panel
       [:div.flex-grid-group
        [:div
         {:class (u/bem :flex-grid-block [:m-1-2])}
         [:div.flex-grid-content
          [:div.callout-panel__hero
           [:div.u-max-width-490
            (web-common/lazy-image app-atom
              (:doc/public-id banner)
              {:class ["yc-simple-image yc-simple-image--shadow yc-simple-image--full"]}
              {:w 599
               :h 328
               :c "lpad"
               :q "auto"
               :alt (:ent/display-name collection)})]]]]
        [:div
         {:class (u/bem :flex-grid-block [:m-1-2])}
         [:div.flex-grid-content
          [:div.callout-panel__content
           (headings/heading (:ent/display-name collection)
             {:type :h1
              :size :medium})
           [:p.callout-panel__description description]
           (cond
             user
             (buttons/button-web "Add Collection to Registry"
               {:style :secondary
                :size :default
                :on-click
                #(do
                   (swap! process-atom assoc
                     :collection/uuid (:ent/uuid collection)
                     :registry-action :add-collection)
                   (grid/dispatch-action app-atom :web.registry/edit.choose {}))})

             :else
             (buttons/button-web "Add Collection to Registry"
               {:style :secondary
                :size :default
                :on-click #(grid/open-modal app-atom :web.registry/no-registry-modal)}))]]]]]]
     [:div
      {:class (u/bem :yc-section [:medium])}
      [:div
       {:class (u/bem :flex-grid-group [:align-left])}
       (map (partial collection-product-card app-atom) items)]]
     [:div
      {:class (u/bem :yc-section [:large])}
      [:div.u-block-center.u-max-width-320
       (cond
         user
         (buttons/button-web "Add all to registry"
           {:style :primary
            :size :large
            :full true
            :on-click
            #(do
               (swap! process-atom assoc
                 :collection/uuid (:ent/uuid collection)
                 :registry-action :add-collection)
               (grid/dispatch-action app-atom :web.registry/edit.choose {}))})

         :else
         (buttons/button-web "Add all to registry"
           {:style :primary
            :size :large
            :full true
            :on-click #(grid/open-modal app-atom :web.registry/no-registry-modal)}))]]
     (toaster/loading-overlay app-atom :web.registry/collection-detail)]))

(defmethod flow/render-screen :web.registry/collectionlist [app-atom _]
  (website/screen-wrapper app-atom
    (starter-collections app-atom)
    {:pagetype :registry}))

(defmethod t/transition-open :web.registry/collectionlist [app-atom _ _]
  (toaster/open-overlay app-atom :web.registry/collection-list)
  (comms/ajax-get :web.registry/collection-list {}))

(defmethod comms/receive :web.registry/collection-list [app-atom {:keys [collections]}]
  (swap! (cmn/process-cursor app-atom) assoc
    :collections collections)
  (toaster/close-overlay app-atom :web.registry/collection-list))

(defmethod flow/render-screen :web.registry/collectiondetail [app-atom _]
  (website/screen-wrapper app-atom
    (starter-collection app-atom)
    {:pagetype :registry}))

(defmethod t/transition-open :web.registry/collectiondetail [app-atom _ params]
  (let [process-atom (cmn/process-cursor app-atom)]
    (toaster/open-overlay app-atom :web.registry/collection-detail)
    (reset! process-atom nil)
    (comms/ajax-get :web.registry/collection-detail (select-keys params [:uuid]))))

(defmethod comms/receive :web.registry/collection-detail [app-atom {:keys [collection]}]
  (swap! (cmn/process-cursor app-atom) assoc
    :collection collection)
  (toaster/close-overlay app-atom :web.registry/collection-detail))